<template>
  <div class="app__range range">
    <span
      class="range__val"
      ref="val"
    >{{ value }}</span>
    <input
      ref="range"
      class="range__input"
      type="range"
      min="0"
      max="100"
      step="10"
      v-model="value"
      @mouseup="handlerMouseup"
      @touchend="handlerMouseup"
      @change="setPositionVal"
      @input="setPositionVal"
    >
  </div>
</template>

<script>
import { mapState } from 'vuex';
import audio from '@/scripts/audio';

export default {
  name: 'GameRange',

  data() {
    return {
      value: 50,
      left: 0,
    };
  },

  computed: {
    ...mapState({
      game: 'currentGame',
    }),
  },

  mounted() {
    this.setPositionVal();
    this.$eventHub.$on('resizeWindow', this.setPositionVal);
  },

  methods: {
    handlerMouseup() {
      this.$store.dispatch('checkAnswer', parseInt(this.value, 10));
      this.$eventHub.$emit('count-down-stop');
      audio.play('click');
    },
    setPositionVal() {
      if (this.$refs.range === undefined) return;

      const max = parseInt(this.$refs.range.getAttribute('max'), 10);
      const normValue = this.value;
      const percent = (normValue / max);
      const { width } = this.$refs.val ? this.$refs.val.getBoundingClientRect() : 0;

      if (this.$refs.val) this.$refs.val.style.left = `calc(${percent * 100}% - ${width * percent}px)`;
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('resizeWindow', this.setPositionVal);
  },
};
</script>

<style lang="scss" scoped>
.range {
  position: relative;
  width: calc(100% - (var(--unit-vw) * 0.25));

  @include mq(ipadP) {
    width: calc(100% - var(--unit-vw));
  }

  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;

  &__val {
    position: absolute;
    width: 100px;
    bottom: calc(var(--unit-vh) * 0.85);

    color: $color-red;
    font-weight: normal;
    @extend %font-size-l;

    @include mq(ipadP) {
      bottom: calc(var(--unit-vh) * 0.7);
      width: calc(var(--unit-vw) * 1);
    }
  }

  input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    background-color: transparent;

    &:focus {
      border: 0;
      outline: none;
    }
    &:active {
      border: 0;
      outline: none;
    }
    &::-moz-focus-inner {
      border: 0;
      outline: none;
    }
    &::-moz-focus-outer {
      border: 0;
      outline: none;
    }
    &::-moz-focusring {
      border: 0;
      outline: none;
    }
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    width: 80px;
    height: 80px;

    transform: translateY(calc(-50% + (var(--unit-vw) * 0.1)));
    border: 0;
    background-color: transparent;
    background-image: url('/img/svg/thumbs-range.svg');

    transform: scale(0);
    transition: transform 0.5s cubic-bezier(.5, 0, 0, 1);

    @include mq(ipadP) {
      width: calc(var(--unit-vw) * 1);
      height: calc(var(--unit-vw) * 1);
    }

    cursor: pointer;
  }
  input[type=range]::-moz-range-thumb {
    position: relative;
    width: 80px;
    height: 80px;

    border: 0;
    background-color: transparent;
    background-image: url('/img/svg/thumbs-range.svg');

    transform: scale(0);
    transition: transform 0.5s cubic-bezier(.5, 0, 0, 1);

    @include mq(ipadP) {
      width: calc(var(--unit-vw) * 1);
      height: calc(var(--unit-vw) * 1);
    }

    cursor: pointer;
  }

  input[type=range]::-webkit-slider-runnable-track {
    height: calc(var(--unit-vw) * 0.15);

    background-color: $color-yellow;
    border-radius: calc(var(--unit-vw) * 0.2);
  }
  input[type=range]::-moz-range-track {
    height: calc(var(--unit-vw) * 0.15);

    background-color: $color-yellow;
    border-radius: calc(var(--unit-vw) * 0.2);
  }

  &[data-animated] {
    input[type=range]::-webkit-slider-thumb {
      transform: scale(1) translateY(calc(-50% + (var(--unit-vw) * 0.1)));
      transition: transform 1s cubic-bezier(.5, 0, 0, 1) 1s;
    }
    input[type=range]::-moz-range-thumb {
      transform: scale(1);
      transition: transform 1s cubic-bezier(.5, 0, 0, 1) 1s;
    }
  }

  &[data-hover] {
    input[type=range]::-webkit-slider-thumb {
      transition-delay: 0s;
    }
    input[type=range]::-moz-range-thumb {
      transition-delay: 0s;
    }

    input[type="range"]:hover::-moz-range-thumb {
      cursor: grab;
      transform: scale(1.1);
    }
    input[type="range"]:hover::-webkit-slider-thumb {
      cursor: grab;
      transform: scale(1.1) translateY(calc(-50% + (var(--unit-vw) * 0.1)));
    }

    input[type="range"]:active::-moz-range-thumb {
      cursor: grabbing;
      transform: scale(1.2);
    }
    input[type="range"]:active:-webkit-slider-runnable-track {
      cursor: grabbing;
      transform: scale(1.2) translateY(calc(-50% + (var(--unit-vw) * 0.1)));
    }
  }
}
</style>
